import { Injectable } from "@angular/core";
import { ISectionPresenter } from 'src/app/presenters/models/section-presenter';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";

@Injectable({
	providedIn: 'root'
})
export class DPMPowerSettingsSection implements ISectionPresenter {
	constructor(
		private featureToggleService: FeatureToggleService
	) {}

	public async isVisible(): Promise<boolean> {
		return this.featureToggleService.isDeviceSettingsFeatureAvailable(DeviceSettingsFeatureToggle.PowerDPMPowerSettings);
	}
}
